import React, { useEffect, useState, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressBook,
  faUserTie,
  faAngleDown,
  faAngleUp,
  faArrowDown,
  faArrowUp,
  faEdit,
  faEllipsisH,
  faExternalLinkAlt,
  faEye,
  faTrashAlt,
  faHandHoldingUsd,
  faCheckCircle,
  faTimesCircle,
  faQuestionCircle,
  faClock,
  faDownload,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Nav,
  Card,
  Image,
  Button,
  Table,
  Dropdown,
  ProgressBar,
  Pagination,
  ButtonGroup,
  Alert,
} from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Popover from "react-bootstrap/Popover";
import { Link } from "react-router-dom";
import { Routes } from "../routes";
import { pageVisits, pageTraffic, pageRanking } from "../data/tables";
import transactions from "../data/transactions";
import commands from "../data/commands";
import useClient from "../hooks/client.hook";
import useTx from "../hooks/tx.hook";
import FileUpload from "../utils/fileUpload";
import { errorToast, successToast } from "../utils/toast";
import DataTable from "react-data-table-component";
import PropTypes from "prop-types";
import useIbs from "../hooks/ib.hook";
import LoadingComponent from "../components/LoadingComponent";

const verifiedAndActiveStatus = {
  null: {
    icon: faQuestionCircle,
    label: "Desconocido",
    color: null,
  },
  true: {
    icon: faCheckCircle,
    label: "Verificado",
    color: "success",
  },
  false: {
    icon: faTimesCircle,
    label: "No verificado",
    color: "danger",
  },
};
const isNewClientStatus = {
  null: {
    icon: faQuestionCircle,
    label: "Desconocido",
    color: null,
  },
  true: {
    icon: faCheckCircle,
    label: "Nuevo",
    color: "success",
  },
  false: {
    icon: faClock,
    label: "Antiguo",
    color: "",
  },
};

const getVerifiedOrActiveStatus = (status) => {
  return verifiedAndActiveStatus[status];
};

const getisNewClientStatus = (status) => {
  return isNewClientStatus[status];
};

const ValueChange = ({ value, suffix }) => {
  const valueIcon = value < 0 ? faAngleDown : faAngleUp;
  const valueTxtColor = value < 0 ? "text-danger" : "text-success";

  return value ? (
    <span className={valueTxtColor}>
      <FontAwesomeIcon icon={valueIcon} />
      <span className="fw-bold ms-1">
        {Math.abs(value)}
        {suffix}
      </span>
    </span>
  ) : (
    "--"
  );
};

export const PageVisitsTable = () => {
  const TableRow = (props) => {
    const { pageName, views, returnValue, bounceRate } = props;
    const bounceIcon = bounceRate < 0 ? faArrowDown : faArrowUp;
    const bounceTxtColor = bounceRate < 0 ? "text-danger" : "text-success";

    return (
      <tr>
        <th scope="row">{pageName}</th>
        <td>{views}</td>
        <td>${returnValue}</td>
        <td>
          <FontAwesomeIcon
            icon={bounceIcon}
            className={`${bounceTxtColor} me-3`}
          />
          {Math.abs(bounceRate)}%
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="shadow-sm">
      <Card.Header>
        <Row className="align-items-center">
          <Col>
            <h5>Page visits</h5>
          </Col>
          <Col className="text-end">
            <Button variant="secondary" size="sm">
              See all
            </Button>
          </Col>
        </Row>
      </Card.Header>
      <Table responsive className="align-items-center table-flush">
        <thead className="thead-light">
          <tr>
            <th scope="col">Page name</th>
            <th scope="col">Page Views</th>
            <th scope="col">Page Value</th>
            <th scope="col">Bounce rate</th>
          </tr>
        </thead>
        <tbody>
          {pageVisits.map((pv) => (
            <TableRow key={`page-visit-${pv.id}`} {...pv} />
          ))}
        </tbody>
      </Table>
    </Card>
  );
};

export const PageTrafficTable = () => {
  const TableRow = (props) => {
    const {
      id,
      source,
      sourceIcon,
      sourceIconColor,
      sourceType,
      category,
      rank,
      trafficShare,
      change,
    } = props;

    return (
      <tr>
        <td>
          <Card.Link href="#" className="text-primary fw-bold">
            {id}
          </Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon
            icon={sourceIcon}
            className={`icon icon-xs text-${sourceIconColor} w-30`}
          />
          {source}
        </td>
        <td>{sourceType}</td>
        <td>{category ? category : "--"}</td>
        <td>{rank ? rank : "--"}</td>
        <td>
          <Row className="d-flex align-items-center">
            <Col xs={12} xl={2} className="px-0">
              <small className="fw-bold">{trafficShare}%</small>
            </Col>
            <Col xs={12} xl={10} className="px-0 px-xl-1">
              <ProgressBar
                variant="primary"
                className="progress-lg mb-0"
                now={trafficShare}
                min={0}
                max={100}
              />
            </Col>
          </Row>
        </td>
        <td>
          <ValueChange value={change} suffix="%" />
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="shadow-sm mb-4">
      <Card.Body className="pb-0">
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              <th className="border-0">#</th>
              <th className="border-0">Traffic Source</th>
              <th className="border-0">Source Type</th>
              <th className="border-0">Category</th>
              <th className="border-0">Global Rank</th>
              <th className="border-0">Traffic Share</th>
              <th className="border-0">Change</th>
            </tr>
          </thead>
          <tbody>
            {pageTraffic.map((pt) => (
              <TableRow key={`page-traffic-${pt.id}`} {...pt} />
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export const RankingTable = () => {
  const TableRow = (props) => {
    const {
      country,
      countryImage,
      overallRank,
      overallRankChange,
      travelRank,
      travelRankChange,
      widgetsRank,
      widgetsRankChange,
    } = props;

    return (
      <tr>
        <td className="border-0">
          <Card.Link href="#" className="d-flex align-items-center">
            <Image
              src={countryImage}
              className="image-small rounded-circle me-2"
            />
            <div>
              <span className="h6">{country}</span>
            </div>
          </Card.Link>
        </td>
        <td className="fw-bold border-0">{overallRank ? overallRank : "-"}</td>
        <td className="border-0">
          <ValueChange value={overallRankChange} />
        </td>
        <td className="fw-bold border-0">{travelRank ? travelRank : "-"}</td>
        <td className="border-0">
          <ValueChange value={travelRankChange} />
        </td>
        <td className="fw-bold border-0">{widgetsRank ? widgetsRank : "-"}</td>
        <td className="border-0">
          <ValueChange value={widgetsRankChange} />
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="shadow-sm">
      <Card.Body className="pb-0">
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              <th className="border-0">Country</th>
              <th className="border-0">All</th>
              <th className="border-0">All Change</th>
              <th className="border-0">Travel & Local</th>
              <th className="border-0">Travel & Local Change</th>
              <th className="border-0">Widgets</th>
              <th className="border-0">Widgets Change</th>
            </tr>
          </thead>
          <tbody>
            {pageRanking.map((r) => (
              <TableRow key={`ranking-${r.id}`} {...r} />
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export const TransactionsTable = () => {
  const totalTransactions = transactions.length;

  const TableRow = (props) => {
    const { invoiceNumber, subscription, price, issueDate, dueDate, status } =
      props;
    const statusVariant =
      status === "Paid"
        ? "success"
        : status === "Due"
        ? "warning"
        : status === "Canceled"
        ? "danger"
        : "primary";

    return (
      <tr>
        <td>
          <Card.Link as={Link} to={Routes.Invoice.path} className="fw-normal">
            {invoiceNumber}
          </Card.Link>
        </td>
        <td>
          <span className="fw-normal">{subscription}</span>
        </td>
        <td>
          <span className="fw-normal">{issueDate}</span>
        </td>
        <td>
          <span className="fw-normal">{dueDate}</span>
        </td>
        <td>
          <span className="fw-normal">${parseFloat(price).toFixed(2)}</span>
        </td>
        <td>
          <span className={`fw-normal text-${statusVariant}`}>{status}</span>
        </td>
        <td>
          <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle
              as={Button}
              split
              variant="link"
              className="text-dark m-0 p-0"
            >
              <span className="icon icon-sm">
                <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>
                <FontAwesomeIcon icon={faEye} className="me-2" /> View Details
              </Dropdown.Item>
              <Dropdown.Item>
                <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit
              </Dropdown.Item>
              <Dropdown.Item className="text-danger">
                <FontAwesomeIcon icon={faTrashAlt} className="me-2" /> Remove
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="table-wrapper table-responsive shadow-sm">
      <Card.Body className="pt-0">
        <Table hover className="user-table align-items-center">
          <thead>
            <tr>
              <th className="border-bottom">#</th>
              <th className="border-bottom">Bill For</th>
              <th className="border-bottom">Issue Date</th>
              <th className="border-bottom">Due Date</th>
              <th className="border-bottom">Total</th>
              <th className="border-bottom">Status</th>
              <th className="border-bottom">Action</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((t) => (
              <TableRow key={`transaction-${t.invoiceNumber}`} {...t} />
            ))}
          </tbody>
        </Table>
        <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-between">
          <Nav>
            <Pagination className="mb-2 mb-lg-0">
              <Pagination.Prev>Previous</Pagination.Prev>
              <Pagination.Item active>1</Pagination.Item>
              <Pagination.Item>2</Pagination.Item>
              <Pagination.Item>3</Pagination.Item>
              <Pagination.Item>4</Pagination.Item>
              <Pagination.Item>5</Pagination.Item>
              <Pagination.Next>Next</Pagination.Next>
            </Pagination>
          </Nav>
          <small className="fw-bold">
            Showing <b>{totalTransactions}</b> out of <b>25</b> entries
          </small>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
};

export const CommandsTable = () => {
  const TableRow = (props) => {
    const { name, usage = [], description, link } = props;

    return (
      <tr>
        <td className="border-0" style={{ width: "5%" }}>
          <code>{name}</code>
        </td>
        <td className="fw-bold border-0" style={{ width: "5%" }}>
          <ul className="ps-0">
            {usage.map((u) => (
              <ol key={u} className="ps-0">
                <code>{u}</code>
              </ol>
            ))}
          </ul>
        </td>
        <td className="border-0" style={{ width: "50%" }}>
          <pre className="m-0 p-0">{description}</pre>
        </td>
        <td className="border-0" style={{ width: "40%" }}>
          <pre>
            <Card.Link href={link} target="_blank">
              Read More{" "}
              <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
            </Card.Link>
          </pre>
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="shadow-sm">
      <Card.Body className="p-0">
        <Table
          responsive
          className="table-centered rounded"
          style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
        >
          <thead className="thead-light">
            <tr>
              <th className="border-0" style={{ width: "5%" }}>
                Name
              </th>
              <th className="border-0" style={{ width: "5%" }}>
                Usage
              </th>
              <th className="border-0" style={{ width: "50%" }}>
                Description
              </th>
              <th className="border-0" style={{ width: "40%" }}>
                Extra
              </th>
            </tr>
          </thead>
          <tbody>
            {commands.map((c) => (
              <TableRow key={`command-${c.id}`} {...c} />
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export function ExportActionTable({ data, buttonTitle = "Exportar" }) {
  function _download() {
    //downloadCSV(data) // TODO Make export function
  }
  return (
    <>
      <div className="input-group-sm d-flex">
        <Button
          variant="primary"
          size="sm"
          style={{ alignSelf: "end", marginLeft: "10px" }}
          onClick={_download}
        >
          <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
          {buttonTitle}
        </Button>
      </div>
    </>
  );
}
export function SearchActionTable({ PreviousValue, onChange, placeholder }) {
  const [searchValue, setSearchValue] = useState(
    PreviousValue !== undefined && PreviousValue !== null ? PreviousValue : ""
  );

  // HANDLES
  function _performSearch() {
    onChange(searchValue);
  }

  function _handleKeyDown(e) {
    if (e.key === "Enter") {
      _performSearch();
    }
  }

  function _handleSearchButton(e) {
    _performSearch();
  }

  function _handleOnChangeInput(e) {
    setSearchValue(e.target.value);
  }

  return (
    <div className="input-search input-group-sm d-flex">
      <Button
        variant="secondary"
        size="sm"
        style={{ alignSelf: "end", marginLeft: "10px" }}
        onClick={_handleSearchButton}
      >
        <i className="fas fa-search" aria-hidden="true" />
      </Button>
      <input
        type="text"
        className="form-control"
        name=""
        value={searchValue}
        onChange={_handleOnChangeInput}
        placeholder={placeholder ? placeholder : "Buscar cliente..."}
        onKeyDown={_handleKeyDown}
      />
    </div>
  );
}

SearchActionTable.defaultProps = {
  placeholder: "",
};

SearchActionTable.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export function IbsTable(props) {
  const {
    onlyUsers = false,
    actions = [],
    didSearch = undefined,
    generateReport = undefined,
    createReportCallback = undefined,
    deactivateAll = false,
    createIbCallback = undefined,
    selectedCallback = undefined,
    deselectedCallback = undefined,
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { getAllIbs, uploadIbsFile } = useIbs();
  const [ibs, setIbs] = useState(null);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState(null);

  const handlePageChange = (page) => {
    getAllIbs(page, perPage, search, onlyUsers)
      .then((ibsData) => {
        setIbs(ibsData.ibs);
        setTotalRows(ibsData.total);
      })
      .catch((error) => {
        console.log("Error fecthing clients", error);
      });
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    getAllIbs(page, newPerPage, perPage, search, onlyUsers)
      .then((ibsData) => {
        setIbs(ibsData.ibs);
      })
      .catch((error) => {
        console.log("Error fecthing clients", error);
      });
    setPerPage(newPerPage);
  };
  const handleSearchTable = (text) => {
    setSearch(text);
  };

  const tableActions = useMemo(
    () =>
      actions.map((action, index) => {
        if (action.type === "search") {
          return (
            <SearchActionTable
              key={index + action?.type}
              PreviousValue={search}
              onChange={handleSearchTable}
              placeholder="Buscar IB..."
            />
          );
        }
        return action;
      }),
    [props?.actions, search]
  );

  useEffect(() => {
    console.log(currentPage, perPage, search);
    getAllIbs(currentPage, perPage, search, onlyUsers)
      .then((ibsData) => {
        setIbs(ibsData.ibs);
        setTotalRows(ibsData.total);
      })
      .catch((error) => {
        console.log("Error fecthing ibs", error);
      });
    if (search !== null && search !== "" && props.didSearch !== undefined) {
      didSearch(true);
    } else if ((search === null || search === "") && didSearch !== undefined) {
      didSearch(false);
    }
  }, [search]);

  const columns = useMemo(() => [
    {
      name: "Número de IB",
      selector: (row) => {
        return <div>{row["ib_number"]}</div>;
      },
      grow: 1,
    },

    {
      name: "Número de cuenta",
      selector: (row) => {
        return <div>{row["account_number"]}</div>;
      },
      grow: 1,
      omit: onlyUsers 
    },
    {
      name: "Nombre",
      selector: (row) => {
        return <div>{row["name"]}</div>;
      },
      grow: 1,
    },
    // {
    //   name: "País",
    //   selector: (row) => {  return (<div >{row["country"]}</div>)},
    //   width: 50,
    //   minWidth: 50,
    //   maxWidth: 50,
    //   sortable: true,
    // },
    {
      name: "Correo electrónico",
      selector: (row) => {
        return <div>{row["email"]}</div>;
      },
      width: 50,
      minWidth: 50,
      maxWidth: 50,
    },
    {
      name: "Link en plataforma",
      selector: (row) => {
        return (
          <div>
            <a href={row["ib_link"]} style={{ color: "black" }}>
              <FontAwesomeIcon icon={faExternalLinkAlt} />
            </a>
          </div>
        );
      },
      width: 50,
      minWidth: 50,
      maxWidth: 50,
      omit: onlyUsers
    },
  ]);
  return (
    <>
      {ibs !== undefined && ibs !== null && ibs.length > 0 ? (
        <Card border="light" className="shadow-sm">
          <Card.Header>
            <Row className="align-items-center">
              <Col>
                <h5>
                  <FontAwesomeIcon icon={faUserTie} /> Afiliados comerciales
                  actuales
                </h5>
              </Col>
              <Col
                className="text-end d-flex"
                style={{ justifyContent: "flex-end" }}
              >
                {generateReport !== undefined &&
                  createReportCallback !== undefined && (
                    <Button
                      variant="secondary"
                      size="sm"
                      style={{ alignSelf: "end", marginLeft: "10px" }}
                      onClick={(e) => createReportCallback()}
                    >
                      Generar Reportes de Afiliados
                    </Button>
                  )}
                {tableActions}
                {deactivateAll !== undefined ? (
                  <></>
                ) : (
                  <Link to={Routes.IBs.path}>
                    <Button
                      variant="secondary"
                      size="sm"
                      style={{ alignSelf: "end", marginLeft: "10px" }}
                      to={Routes.IBs.path}
                    >
                      Ver todos
                    </Button>
                  </Link>
                )}
                {deactivateAll !== undefined &&
                  createIbCallback !== undefined && (
                    <Button
                      variant="secondary"
                      size="sm"
                      style={{ alignSelf: "end", marginLeft: "10px" }}
                      onClick={(e) =>
                        createIbCallback().then((result) => {
                          console.log("FINISHED CREATING!");
                          getAllIbs(currentPage, perPage, search, onlyUsers)
                            .then((ibsData) => {
                              setIbs(ibsData.ibs);
                              setTotalRows(ibsData.total);
                            })
                            .catch((error) => {
                              console.log("Error fecthing clients", error);
                            });
                          setCurrentPage(currentPage);
                        })
                      }
                    >
                      Crear Afiliado
                    </Button>
                  )}
              </Col>
            </Row>
          </Card.Header>
          <DataTable
            striped
            highlightOnHover
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            paginationComponentOptions={{
              rowsPerPageText: "Clientes por página",
              rangeSeparatorText: "de",
              noRowsPerPage: true,
            }}
            rowsPerPage={perPage}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            columns={columns}
            data={ibs}
            selectableRows={
              selectedCallback !== undefined && selectedCallback !== null
                ? true
                : false
            }
            onSelectedRowsChange={
              selectedCallback !== undefined && selectedCallback !== null
                ? selectedCallback
                : undefined
            }
            selectableRowsHighlight={
              selectedCallback !== undefined && selectedCallback !== null
                ? true
                : false
            }
            selectableRowsNoSelectAll={true}
            selectableRowDisabled={
              deselectedCallback !== undefined && deselectedCallback !== null
                ? deselectedCallback
                : undefined
            }
            noDataComponent={"No existen clientes que mostrar"}
          />
        </Card>
      ) : (
        <>
          {search === null && (
            <>
              <Card border="light" className="shadow-sm">
                {isLoading && (
                  <>
                    <LoadingComponent className="d-flex align-items-center justify-content-center"></LoadingComponent>
                  </>
                )}
                <Card.Header style={{ marginBottom: "20px" }}>
                  <Row className="align-items-center">
                    <Col>
                      <h5>Afiliados comerciales</h5>
                    </Col>
                    <Col className="text-end">
                      {props?.deactivateAll !== undefined ? (
                        <></>
                      ) : (
                        <Link to={Routes.IBs.path}>
                          <Button
                            variant="secondary"
                            size="sm"
                            to={Routes.IBs.path}
                          >
                            Ver todos
                          </Button>
                        </Link>
                      )}
                      {props?.deactivateAll !== undefined &&
                        props.createIbCallback !== undefined && (
                          <Button
                            variant="secondary"
                            size="sm"
                            style={{ alignSelf: "end", marginLeft: "10px" }}
                            onClick={(e) => props.createIbCallback()}
                          >
                            Crear Afiliado
                          </Button>
                        )}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-center text-md-center">
                      <Alert variant={"warning"} style={{ margin: "15px" }}>
                        Oops! Al parecer no tienes <b> IBs </b> cargados al
                        sistema <br /> Por favor sube un archivo modelo para
                        cargar IBs
                      </Alert>
                    </Col>
                  </Row>
                </Card.Header>
                <FileUpload
                  filesCallback={(e) => {
                    setIsLoading(true);
                    uploadIbsFile(e)
                      .then((response) => {
                        setIsLoading(false);
                        successToast(
                          "Haz subido con exito el documento de IBs"
                        );
                        getAllIbs(currentPage, perPage, search, onlyUsers)
                          .then((ibsData) => {
                            setIbs(ibsData.ibs);
                            setTotalRows(ibsData.total);
                          })
                          .catch((error) => {
                            console.log("Error fecthing ibs", error);
                          });
                      })
                      .catch(async (error) => {
                        setIsLoading(false);
                        await errorToast(error);
                      });
                  }}
                />
              </Card>
            </>
          )}
          {search !== null && (
            <>
              <Card border="light" className="shadow-sm">
                <Card.Header>
                  <Row className="align-items-center">
                    <Col>
                      <h5>
                        <FontAwesomeIcon icon={faUserTie} /> Afiliados
                        comerciales actuales
                      </h5>
                    </Col>
                    <Col
                      className="text-end d-flex"
                      style={{ justifyContent: "flex-end" }}
                    >
                      {props?.generateReport !== undefined &&
                        props.createReportCallback !== undefined && (
                          <Button
                            variant="secondary"
                            size="sm"
                            style={{ alignSelf: "end", marginLeft: "10px" }}
                            onClick={(e) => props.createReportCallback()}
                          >
                            Generar Reportes de Afiliados
                          </Button>
                        )}
                      {tableActions}
                      {props?.deactivateAll !== undefined ? (
                        <></>
                      ) : (
                        <Link to={Routes.IBs.path}>
                          <Button
                            variant="secondary"
                            size="sm"
                            style={{ alignSelf: "end", marginLeft: "10px" }}
                          >
                            Ver todos
                          </Button>
                        </Link>
                      )}
                      {props?.deactivateAll !== undefined &&
                        props.createIbCallback !== undefined && (
                          <Button
                            variant="secondary"
                            size="sm"
                            style={{ alignSelf: "end", marginLeft: "10px" }}
                            onClick={(e) => props.createIbCallback()}
                          >
                            Crear Afiliado
                          </Button>
                        )}
                    </Col>
                  </Row>
                </Card.Header>
                <DataTable
                  striped
                  highlightOnHover
                  sortServer
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  paginationComponentOptions={{
                    rowsPerPageText: "Clientes por página",
                    rangeSeparatorText: "de",
                    noRowsPerPage: true,
                  }}
                  rowsPerPage={perPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  columns={columns}
                  data={ibs}
                  selectableRows={
                    props?.selectedCallback !== undefined &&
                    props?.selectedCallback !== null
                      ? true
                      : false
                  }
                  onSelectedRowsChange={
                    props?.selectedCallback !== undefined &&
                    props?.selectedCallback !== null
                      ? props?.selectedCallback
                      : undefined
                  }
                  noDataComponent={"No existen clientes que mostrar"}
                />
              </Card>
            </>
          )}
        </>
      )}
    </>
  );
}

export function TxTable(props) {
  const [isLoading, setIsLoading] = useState(false);
  const { getAllTx } = useTx();
  const [txs, setTxs] = useState(null);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [search, setSearch] = useState(null);

  const handlePageChange = (page) => {
    getAllTx(page, perPage)
      .then((txData) => {
        setTxs(txData.txs);
        setTotalRows(txData.total);
      })
      .catch((error) => {
        console.log("Error fecthing transactions", error);
      });
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    getAllTx(page, newPerPage)
      .then((txData) => {
        setTxs(txData.txs);
      })
      .catch((error) => {
        console.log("Error fecthing transactions", error);
      });
    setPerPage(newPerPage);
  };

  const handleSearchTable = (text) => {
    setSearch(text);
    console.log(search);
  };

  const tableActions = useMemo(
    () =>
      props?.actions.map((action, index) => {
        if (action.type === "search") {
          return (
            <SearchActionTable
              key={index + props?.type}
              onChange={handleSearchTable}
              PreviousValue={search}
              placeholder="Buscar transacción..."
            />
          );
        }
        return action;
      }),
    [props?.actions, search]
  );

  useEffect(() => {
    console.log(currentPage, perPage, search);
    getAllTx(currentPage, perPage, search)
      .then((txData) => {
        setTxs(txData.txs);
        setTotalRows(txData.total);
      })
      .catch((error) => {
        console.log("Error fecthing clients", error);
      });
  }, [search]);

  const columns = useMemo(() => [
    {
      name: "Número de Afiliado",
      selector: (row) => {
        return <div>{row["ib_number"]}</div>;
      },
      grow: 1,
    },
    {
      name: "Número de cuenta de cliente",
      selector: (row) => {
        return <div>{row["client_id"]}</div>;
      },
      width: 50,
      minWidth: 50,
      maxWidth: 50,
    },
    {
      name: "Grupo",
      selector: (row) => row["product"],
      grow: 1,
    },
    {
      name: "Schema",
      selector: (row) => row["platform"],
      grow: 1,
      sortable: true,
    },
    {
      name: "Volumen",
      selector: (row) => {
        return <div>{row["volume"]}</div>;
      },
      sortable: true,
    },
    {
      name: "Valor del lote",
      selector: (row) => row["lot_value"],
      sortable: true,
    },
    {
      name: "Simbolo",
      selector: (row) => row["asset"],
      sortable: true,
    },
    {
      name: "Fecha de registro",
      selector: (row) => row["last_tx_date"].split("T")[0],
      grow: 1,
    },
  ]);
  return (
    <>
      {txs !== undefined && txs !== null && txs.length > 0 ? (
        <Card border="light" className="shadow-sm">
          <Card.Header>
            <Row className="align-items-center">
              <Col>
                <h5>
                  <FontAwesomeIcon icon={faHandHoldingUsd} /> Transacciones
                  actuales
                </h5>
              </Col>
              <Col
                className="text-end d-flex"
                style={{ justifyContent: "flex-end" }}
              >
                {props?.uploadTxFile !== undefined &&
                  props.uploadTxFileCallback !== undefined && (
                    <Button
                      variant="secondary"
                      size="sm"
                      style={{ alignSelf: "end", marginLeft: "10px" }}
                      onClick={(e) => props.uploadTxFileCallback()}
                    >
                      Subir transacciones
                    </Button>
                  )}
                {tableActions}
                {props?.deactivateAll !== undefined ? (
                  <></>
                ) : (
                  <Link to={Routes.Transactions.path}>
                    <Button
                      variant="secondary"
                      size="sm"
                      style={{ alignSelf: "end", marginLeft: "10px" }}
                      to={Routes.Transactions.path}
                    >
                      Ver todos
                    </Button>
                  </Link>
                )}
              </Col>
            </Row>
          </Card.Header>
          <DataTable
            striped
            highlightOnHover
            pagination
            paginationServer
            paginationPerPage={perPage}
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            paginationComponentOptions={{
              rowsPerPageText: "Transacciones por página",
              rangeSeparatorText: "de",
              noRowsPerPage: true,
            }}
            rowsPerPage={perPage}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            columns={columns}
            data={txs}
            noDataComponent={"No existen transacciones que mostrar"}
          />
        </Card>
      ) : (
        <>
          {search !== null && (
            <>
              <Card border="light" className="shadow-sm">
                <Card.Header>
                  <Row className="align-items-center">
                    <Col>
                      <h5>
                        <FontAwesomeIcon icon={faHandHoldingUsd} />{" "}
                        Transacciones actuales
                      </h5>
                    </Col>
                    <Col
                      className="text-end d-flex"
                      style={{ justifyContent: "flex-end" }}
                    >
                      {props?.uploadTxFile !== undefined &&
                        props.uploadTxFileCallback !== undefined && (
                          <Button
                            variant="secondary"
                            size="sm"
                            style={{ alignSelf: "end", marginLeft: "10px" }}
                            onClick={(e) => props.uploadTxFileCallback()}
                          >
                            Subir transacciones
                          </Button>
                        )}
                      {tableActions}
                      {props?.deactivateAll !== undefined ? (
                        <></>
                      ) : (
                        <Link to={Routes.Transactions.path}>
                          <Button
                            variant="secondary"
                            size="sm"
                            style={{ alignSelf: "end", marginLeft: "10px" }}
                            to={Routes.Transactions.path}
                          >
                            Ver todos
                          </Button>
                        </Link>
                      )}
                    </Col>
                  </Row>
                </Card.Header>
                <DataTable
                  striped
                  highlightOnHover
                  sortServer
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  paginationComponentOptions={{
                    rowsPerPageText: "Transacciones por página",
                    rangeSeparatorText: "de",
                    noRowsPerPage: true,
                  }}
                  rowsPerPage={perPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  columns={columns}
                  data={txs}
                  noDataComponent={"No existen transacciones que mostrar"}
                />
              </Card>
            </>
          )}
          {search === null && (
            <>
              <Card border="light" className="shadow-sm">
                {isLoading && (
                  <>
                    <LoadingComponent className="d-flex align-items-center justify-content-center"></LoadingComponent>
                  </>
                )}
                <Card.Header style={{ marginBottom: "20px" }}>
                  <Row className="align-items-center">
                    <Col>
                      <h5>
                        <FontAwesomeIcon icon={faHandHoldingUsd} />{" "}
                        Transacciones actuales
                      </h5>
                    </Col>
                    <Col className="text-end">
                      {props?.deactivateAll !== undefined ? (
                        <></>
                      ) : (
                        <Link to={Routes.Transactions.path}>
                          <Button
                            variant="secondary"
                            size="sm"
                            style={{ alignSelf: "end", marginLeft: "10px" }}
                            to={Routes.Transactions.path}
                          >
                            Ver todos
                          </Button>
                        </Link>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-center text-md-center">
                      <Alert variant={"warning"} style={{ margin: "15px" }}>
                        Oops! Al parecer no tienes <b> transacciones </b>{" "}
                        cargadas al sistema <br /> Por favor sube un archivo de
                        operaciones del mes de los clientes afiliados con el
                        botón <b> Subir transacciones</b>
                      </Alert>
                      <Button
                        variant="secondary"
                        size="sm"
                        style={{ alignSelf: "end", marginLeft: "10px" }}
                        onClick={(e) => props.uploadTxFileCallback()}
                      >
                        Subir transacciones
                      </Button>
                    </Col>
                  </Row>
                </Card.Header>
              </Card>
            </>
          )}
        </>
      )}
    </>
  );
}

export function ClientsTable(props) {
  const [isLoading, setIsLoading] = useState(false);
  const { getAllClients, uploadClientsFile } = useClient();
  const [clients, setClients] = useState(null);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState(null);

  const handlePageChange = (page) => {
    getAllClients(page, perPage)
      .then((clientsData) => {
        setClients(clientsData.clients);
        setTotalRows(clientsData.total);
      })
      .catch((error) => {
        console.log("Error fecthing clients", error);
      });
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    getAllClients(page, newPerPage)
      .then((clientsData) => {
        setClients(clientsData.clients);
      })
      .catch((error) => {
        console.log("Error fecthing clients", error);
      });
    setPerPage(newPerPage);
  };

  const handleSearchTable = (text) => {
    setSearch(text);
    console.log(search);
  };

  const tableActions = useMemo(
    () =>
      props?.actions.map((action, index) => {
        if (action.type === "search") {
          return (
            <SearchActionTable
              key={index + props?.type}
              onChange={handleSearchTable}
              PreviousValue={search}
              placeholder="Buscar cliente..."
            />
          );
        }
        if (action.type === "export") {
          return <ExportActionTable data={clients} />;
        }
        return action;
      }),
    [props?.actions, search]
  );

  useEffect(() => {
    getAllClients(currentPage, perPage, search)
      .then((clientsData) => {
        setClients(clientsData.clients);
        setTotalRows(clientsData.total);
      })
      .catch((error) => {
        console.log("Error fecthing clients", error);
      });
  }, [search]);

  const getColumns = () => {
    if (!props.showIbNumbRow) {
      return [
        {
          name: "Nombre",
          selector: (row) => {
            return <div>{row["name"]}</div>;
          },
          grow: 1,
        },
        {
          name: "País",
          selector: (row) => {
            return <div>{row["country"]}</div>;
          },
          width: 50,
          minWidth: 50,
          maxWidth: 50,
        },
        {
          name: "Número de cuenta",
          selector: (row) => {
            return <div>{row["account_number"]}</div>;
          },
          grow: 1,
        },
        {
          name: "Número(s) de teléfono",
          selector: (row) => {
            return (
              <div>
                {row["contacts"] !== undefined &&
                  row["contacts"].length == 1 && (
                    <b>{row["contacts"][0].phone}</b>
                  )}
                {row["contacts"] !== undefined &&
                  row["contacts"].length > 1 && (
                    <Dropdown.Menu>
                      {row["contacts"]
                        .map((contactInfo) => contactInfo.phone)
                        .forEach((Phone) => {
                          return (
                            <Dropdown.Item className="text-center text-primary fw-bold py-3">
                              {" "}
                              {Phone}
                            </Dropdown.Item>
                          );
                        })}
                    </Dropdown.Menu>
                  )}
                {row["contacts"] === undefined &&
                  row["phone"] !== undefined && <b>{row.phone}</b>}
              </div>
            );
          },
          grow: 1,
        },
        {
          name: "Email",
          selector: (row) => {
            return (
              <div>
                {row["contacts"] !== undefined &&
                  row["contacts"].length == 1 && (
                    <b>{row["contacts"][0].email}</b>
                  )}
                {row["contacts"] !== undefined &&
                  row["contacts"].length > 1 && (
                    <Dropdown.Menu>
                      {row["contacts"]
                        .map((contactInfo) => contactInfo.email)
                        .forEach((email) => {
                          return (
                            <Dropdown.Item className="text-center text-primary fw-bold py-3">
                              {" "}
                              {email}
                            </Dropdown.Item>
                          );
                        })}
                    </Dropdown.Menu>
                  )}
                {row["contacts"] === undefined &&
                  row["email"] !== undefined && <b>{row.email}</b>}
              </div>
            );
          },
          grow: 1,
        },
      ];
    }
    return [
      {
        name: "Nombre",
        selector: (row, index) => {
          return (
            <div>
              <OverlayTrigger
                key={index}
                placement={"top"}
                overlay={
                  <Tooltip id={`name-tooltip-${index}-top`}>
                    <strong>{row["name"]}</strong>
                  </Tooltip>
                }
              >
                <span>{row["name"]}</span>
              </OverlayTrigger>
            </div>
          );
        },
        grow: 3,
      },
      {
        name: "País",
        selector: (row) => {
          return <div>{row["country"].split(",")[0]}</div>;
        },
        width: 50,
        minWidth: 50,
        maxWidth: 50,
      },
      {
        name: "Número de cuenta",
        selector: (row) => {
          return Number(row.account_number);
        },
        grow: 1.5,
      },
      {
        name: "Número de IB",
        selector: (row) => Number(row.ib_number),
        grow: 2,
      },
      {
        name: "Número(s) de teléfono",
        selector: (row, index) => {
          return (
            <div>
              {row["contacts"] !== undefined && row["contacts"].length == 1 && (
                <b>{row["contacts"][0].phone}</b>
              )}
              {row["contacts"] !== undefined && row["contacts"].length > 1 && (
                <Dropdown.Menu>
                  {row["contacts"]
                    .map((contactInfo) => contactInfo.phone)
                    .forEach((Phone) => {
                      return (
                        <Dropdown.Item className="text-center text-primary fw-bold py-3">
                          {" "}
                          {Phone}
                        </Dropdown.Item>
                      );
                    })}
                </Dropdown.Menu>
              )}
              {row["contacts"] === undefined && row["phone"] !== undefined && (
                <div id={`phone-tooltip-container-${index}-top`}>
                  <OverlayTrigger
                    trigger="click"
                    key={index}
                    placement={"top"}
                    overlay={
                      <Popover id={`phone-tooltip-${index}-top`}>
                        <Button variant="primary">
                          <FontAwesomeIcon
                            icon={faCopy}
                            onClick={async (e) => {
                              navigator.clipboard.writeText(row.phone);
                              await successToast(
                                "Número telefónico ha sido copiado"
                              );
                              setTimeout(
                                document
                                  .getElementById(
                                    `phone-tooltip-container-${index}-top`
                                  )
                                  .childNodes[0].click(),
                                1000
                              );
                            }}
                          ></FontAwesomeIcon>
                        </Button>
                      </Popover>
                    }
                  >
                    <span>{row["phone"]}</span>
                  </OverlayTrigger>
                </div>
              )}
            </div>
          );
        },
        grow: 2,
      },
      {
        name: "Email",
        selector: (row, index) => {
          return (
            <div>
              {row["contacts"] !== undefined && row["contacts"].length == 1 && (
                <b>{row["contacts"][0].email}</b>
              )}
              {row["contacts"] !== undefined && row["contacts"].length > 1 && (
                <Dropdown.Menu>
                  {row["contacts"]
                    .map((contactInfo) => contactInfo.email)
                    .forEach((email) => {
                      return (
                        <Dropdown.Item className="text-center text-primary fw-bold py-3">
                          {" "}
                          {email}
                        </Dropdown.Item>
                      );
                    })}
                </Dropdown.Menu>
              )}
              {row["contacts"] === undefined && row["email"] !== undefined && (
                <div id={`email-tooltip-container-${index}-top`}>
                  <OverlayTrigger
                    trigger="click"
                    key={index}
                    placement={"top"}
                    overlay={
                      <Popover id={`email-tooltip-${index}-top`}>
                        <Button variant="primary">
                          <FontAwesomeIcon
                            icon={faCopy}
                            onClick={async (e) => {
                              navigator.clipboard.writeText(row.email);
                              await successToast(
                                "Correo electrónico ha sido copiado"
                              );
                              setTimeout(
                                document
                                  .getElementById(
                                    `email-tooltip-container-${index}-top`
                                  )
                                  .childNodes[0].click(),
                                1000
                              );
                            }}
                          ></FontAwesomeIcon>
                        </Button>
                      </Popover>
                    }
                  >
                    <span>{row["email"]}</span>
                  </OverlayTrigger>
                </div>
              )}
            </div>
          );
        },
        grow: 3,
      },
      {
        name: "Verificado",
        selector: (row, index) => {
          let status = getVerifiedOrActiveStatus(row["verified"]);
          return (
            <div>
              <OverlayTrigger
                key={index}
                placement={"top"}
                overlay={
                  <Tooltip id={`tooltip-${index}-top`}>
                    <strong>{status.label}</strong>
                  </Tooltip>
                }
              >
                <span
                  className={`text-${
                    status.color === null ? "" : status.color
                  }`}
                >
                  <FontAwesomeIcon icon={status.icon} />
                </span>
              </OverlayTrigger>
            </div>
          );
        },
        grow: 0.5,
      },
      {
        name: "Es nuevo",
        selector: (row, index) => {
          let status = getisNewClientStatus(row["new_registration_status"]);
          return (
            <div>
              <OverlayTrigger
                key={index}
                placement={"top"}
                overlay={
                  <Tooltip id={`tooltip-${index}-top`}>
                    <strong>{status.label}</strong>
                  </Tooltip>
                }
              >
                <span
                  className={`text-${
                    status.color === null ? "" : status.color
                  }`}
                >
                  <FontAwesomeIcon icon={status.icon} />
                </span>
              </OverlayTrigger>
            </div>
          );
        },
        grow: 0.5,
      },
      {
        name: "Depositó",
        selector: (row, index) => {
          let status = getisNewClientStatus(row["new_deposited_this_month"]);
          return (
            <div>
              <OverlayTrigger
                key={index}
                placement={"top"}
                overlay={
                  <Tooltip id={`tooltip-${index}-top`}>
                    <strong>{status.label}</strong>
                  </Tooltip>
                }
              >
                <span
                  className={`text-${
                    status.color === null ? "" : status.color
                  }`}
                >
                  <FontAwesomeIcon icon={status.icon} />
                </span>
              </OverlayTrigger>
            </div>
          );
        },
        grow: 0.5,
      },
    ];
  };

  const columns = useMemo(() => {
    return getColumns();
  });

  return (
    <>
      {clients !== undefined && clients !== null && clients.length > 0 ? (
        <Card border="light" className="shadow-sm">
          <Card.Header>
            <Row className="align-items-center">
              <Col>
                <h5>
                  <FontAwesomeIcon icon={faAddressBook} /> Clientes actuales
                </h5>
              </Col>
              <Col
                className="text-end d-flex"
                style={{ justifyContent: "flex-end" }}
              >
                {tableActions}
                {props?.deactivateAll !== undefined ? (
                  <></>
                ) : (
                  <Link to={Routes.Clients.path}>
                    <Button
                      variant="secondary"
                      size="sm"
                      style={{ alignSelf: "end", marginLeft: "10px" }}
                      to={Routes.Clients.path}
                    >
                      Ver todos
                    </Button>
                  </Link>
                )}
              </Col>
            </Row>
          </Card.Header>
          <DataTable
            striped
            highlightOnHover
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            paginationComponentOptions={{
              rowsPerPageText: "Clientes por página",
              rangeSeparatorText: "de",
              noRowsPerPage: true,
            }}
            rowsPerPage={perPage}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            columns={columns}
            data={clients}
            noDataComponent={"No existen clientes que mostrar"}
          />
        </Card>
      ) : (
        <>
          {search !== null && (
            <>
              <Card border="light" className="shadow-sm">
                <Card.Header>
                  <Row className="align-items-center">
                    <Col>
                      <h5>
                        <FontAwesomeIcon icon={faAddressBook} /> Clientes
                        actuales
                      </h5>
                    </Col>
                    <Col
                      className="text-end d-flex"
                      style={{ justifyContent: "flex-end" }}
                    >
                      {tableActions}
                      {props?.deactivateAll !== undefined ? (
                        <></>
                      ) : (
                        <Link to={Routes.Clients.path}>
                          <Button
                            variant="secondary"
                            size="sm"
                            style={{ alignSelf: "end", marginLeft: "10px" }}
                            to={Routes.Clients.path}
                          >
                            Ver todos
                          </Button>
                        </Link>
                      )}
                    </Col>
                  </Row>
                </Card.Header>
                <DataTable
                  striped
                  highlightOnHover
                  sortServer
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  paginationComponentOptions={{
                    rowsPerPageText: "Clientes por página",
                    rangeSeparatorText: "de",
                    noRowsPerPage: true,
                  }}
                  rowsPerPage={perPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  columns={columns}
                  data={clients}
                  noDataComponent={"No existen clientes que mostrar"}
                />
              </Card>
            </>
          )}
          {search === null && (
            <>
              <Card border="light" className="shadow-sm">
                {isLoading && (
                  <>
                    <LoadingComponent className="d-flex align-items-center justify-content-center"></LoadingComponent>
                  </>
                )}
                <Card.Header style={{ marginBottom: "20px" }}>
                  <Row className="align-items-center">
                    <Col>
                      <h5>Clientes</h5>
                    </Col>
                    <Col className="text-end">
                      {props?.deactivateAll !== undefined ? (
                        <></>
                      ) : (
                        <Link to={Routes.Clients.path}>
                          <Button
                            variant="secondary"
                            size="sm"
                            style={{ alignSelf: "end", marginLeft: "10px" }}
                            to={Routes.Clients.path}
                          >
                            Ver todos
                          </Button>
                        </Link>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-center text-md-center">
                      <Alert variant={"warning"} style={{ margin: "15px" }}>
                        Oops! Al parecer no tienes <b> Clientes </b> cargados al
                        sistema <br /> Por favor sube un archivo modelo para
                        cargar clientes
                      </Alert>
                    </Col>
                  </Row>
                </Card.Header>
                <FileUpload
                  excludeExcel={true}
                  filesCallback={(e) => {
                    setIsLoading(true);
                    uploadClientsFile(e)
                      .then((response) => {
                        setIsLoading(false);
                        successToast(
                          "Haz subido con exito el documento de clientes"
                        );
                        getAllClients(currentPage, perPage, search)
                          .then((clientsData) => {
                            setClients(clientsData.clients);
                            setTotalRows(clientsData.total);
                          })
                          .catch((error) => {
                            console.log("Error fecthing clients", error);
                          });
                      })
                      .catch(async (error) => {
                        setIsLoading(false);
                        await errorToast(error);
                      });
                  }}
                />
              </Card>
            </>
          )}
        </>
      )}
    </>
  );
}
